import { StyledTable, StyledStickyBorderTable } from './StyledTableComponents';
import { useTrellisTheme } from '../../utils/useTrellisTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultTableComponent = ({
  children,
  numberOfFrozenColumns = 0,
  requiredTableProps,
  zebraStripe = false
}) => {
  const theme = useTrellisTheme();
  const Component = numberOfFrozenColumns > 0 ? StyledStickyBorderTable : StyledTable;
  return /*#__PURE__*/_jsx(Component
  // Overrides contextual styles when rendered in a card
  , Object.assign({
    bordered: true,
    condensed: true,
    flush: true,
    responsive: false
  }, requiredTableProps, {
    zebraStripe: zebraStripe,
    $theme: theme,
    children: children
  }));
};